var angular = require('angular');
var app = angular.module('learn-directives');
import React from 'react';
import { createRoot } from 'react-dom/client';
import Layout from '../edit-survey-app';

const creatorOpts = {
  showLogicTab: false,
  showJSONEditorTab: false,
  showPropertyGrid: false,
  showSideBar: false,
  questionTypes: [
    "checkbox",
    "radiogroup",
    "comment",
  ],
  isAutoSave: true,
  pageEditMode: "single",
  haveCommercialLicense: true
}

const whiteList = [
  'title',
  'name',
  'description',
  'required',
  'choices',
  'showOtherItem',
  'showSelectAllItem',
  'showNoneItem',
  'inputType',
  'placeholder',
  'rows',
  'locale',
  'showTitle',
]

const layoutVars = {
  survey: null,
  saveQuestions: null,
  userLanguage: null
}
function renderLayout(root, creatorVars, whiteList, survey, saveQuestions, userLanguage) {
  root.render(
    <Layout
      creatorOptions={creatorVars}
      whiteList={whiteList}
      survey={layoutVars.survey}
      saveQuestions={layoutVars.saveQuestions}
      userLanguage={layoutVars.userLanguage}
    />
  );
}

const reactDirective = app.directive('editSurveyDirective', [
  'Application',
  function (Application) {
    self.featureFlags = Application.features.flags();
    return {
      template:
        `<div id="edit-survey-app" class="react-part"></div>`,
      scope: {
        survey: '=',
        saveQuestions: '&',
        userLanguage: '<'
      },
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById("edit-survey-app");
        const root = createRoot(reactapp);
        scope.$watch(
          'survey',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.survey = newVal;
              renderLayout(root, creatorOpts, whiteList, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'saveQuestions',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.saveQuestions = newVal;
              renderLayout(root, creatorOpts, whiteList, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'userLanguage',
          function(newVal, oldVal) {
            if (angular.isDefined(newVal)) {
              layoutVars.userLanguage = newVal;
              renderLayout(root, creatorOpts, whiteList, layoutVars);
            }
          },
          true
        );          
      },
    };
  },
]);


export default reactDirective;